import React from 'react'
import { Container, Box, Typography ,Button} from '@mui/material'
import {
    Faqsaccording1, Faqsaccording2, Faqsaccording3, Faqsaccording4
    , Faqsaccording5, Faqsaccording6, Faqsaccording7
} from "../assets/data"
import Footer from '../components/Footer';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ArrowBtn from '../components/ArrowBtn';
import { Link } from 'react-router-dom';
import useMediaQuery from '@mui/material/useMediaQuery';
import helpimg from "../assets/helpD.png"
const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: 'none',
    boxShadow: 'none',
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon  className='accordion_icon' />}
        {...props}
    />
))(({ theme }) => ({
    flexDirection: 'row',
    padding: 0,
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    }
}));


const Help = () => {
    const matches = useMediaQuery('(max-width:500px)');
    return (
        <>

            <Box className="Hero_main"
                style={{ backgroundImage: `url(${helpimg})`, height: matches ? '100vh' : '120vh' }} >
                <Box className="hero_div">
                    <h1 className='herotitle'>
                    WeCare<br />Help & Advice
                    </h1>
                    <Link to='/BookRepair'>
                        <Button variant="contained" className='herobtn1' >
                            Get a Quote
                        </Button>
                    </Link>
                </Box>
            </Box>
            <Container maxWidth="xl" sx={{ margin: '5rem auto' }}>
                <Box className="faqBoxsec">
                    <Typography variant="h4" fontWeight={600}>FAQs</Typography>
                    <Typography variant="body1" >
                        Welcome to <span className='wecare_faq_span'>WeCare’s </span>boiler care FAQs section! Here, we aim to address  common questions and <br />concerns you may have about boiler  maintenance, troubleshooting, and repairs.
                    </Typography>
                </Box>

                <div>
                    <Box className="acorionswth" >
                        <Typography variant="h3" className='joincol'>Joining Wecare</Typography>
                        {Faqsaccording1.map((item, i) => (
                            <Accordion className='accordionBox helpaccordion' key={i} >
                                <AccordionSummary>
                                    <Typography className='faq_title'>{item.title}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <Typography className='faq_desc'>
                                        {item.desc}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                    <Box className="acorionswth">
                        <Typography variant="h3" className='joincol'>About My Boiler</Typography>
                        {Faqsaccording2.map((item, i) => (
                            <Accordion className='accordionBox helpaccordion' key={i}>
                                <AccordionSummary>
                                    <Typography className='faq_title'>{item.title}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <Typography className='faq_desc'>
                                        {item.desc}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                    <Box className="acorionswth">
                        <Typography variant="h3" className='joincol'>Boiler Servicing</Typography>
                        {Faqsaccording3.map((item, i) => (
                            <Accordion className='accordionBox helpaccordion' key={i}>
                                <AccordionSummary>
                                    <Typography className='faq_title'>{item.title}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <Typography className='faq_desc'>
                                        {item.desc}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                    <Box className="acorionswth">
                        <Typography variant="h3" className='joincol'>Pricing & Payments</Typography>
                        {Faqsaccording4.map((item, i) => (
                            <Accordion className='accordionBox helpaccordion' key={i}>
                                <AccordionSummary>
                                    <Typography className='faq_title'>{item.title}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <Typography className='faq_desc'>
                                        {item.desc}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                    <Box className="acorionswth">
                        <Typography variant="h3" className='joincol'>To Book a  Repair</Typography>
                        {Faqsaccording5.map((item, i) => (
                            <Accordion className='accordionBox helpaccordion' key={i}>
                                <AccordionSummary>
                                    <Typography className='faq_title'>{item.title}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <Typography className='faq_desc'>
                                        {item.desc}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                    <Box className="acorionswth">
                        <Typography variant="h3" className='joincol'>Coverage</Typography>
                        {Faqsaccording6.map((item, i) => (
                            <Accordion className='accordionBox helpaccordion' key={i}>
                                <AccordionSummary>
                                    <Typography className='faq_title'>{item.title}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <Typography className='faq_desc'>
                                        {item.desc}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                    <Box className="acorionswth">
                        <Typography variant="h3" className='joincol'>Existing Customers</Typography>
                        {Faqsaccording7.map((item, i) => (
                            <Accordion className='accordionBox helpaccordion' key={i}>
                                <AccordionSummary>
                                    <Typography className='faq_title'>{item.title}</Typography>
                                </AccordionSummary>
                                <AccordionDetails sx={{ padding: 0 }}>
                                    <Typography className='faq_desc'>
                                        {item.desc}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        ))}
                    </Box>
                </div>


            </Container>
            <Footer />
        </>
    )
}

export default Help
